export class Pays {
  id: number;
  code: string;
  libelle: string;
  nationnalite: string;
  etat: boolean;
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/models/pays.ts